import { ChevronRight } from "lucide-react";
import { Fragment, type ReactElement, type ReactNode } from "react";

import { cn } from "../utils/cn";

export interface BreadcrumbItem {
  label: ReactNode;
  href?: string;
  onClick?: () => void;
}

export interface BreadcrumbProps {
  items: readonly BreadcrumbItem[];
  className?: string;
}

export function Breadcrumb({ items, className }: BreadcrumbProps): ReactElement {
  return (
    <nav
      aria-label="Brotkrumen"
      className={cn("flex min-w-0 items-center gap-1.5 text-sm text-text-tertiary", className)}
    >
      {/* A long job title and candidate name wrap instead of widening a phone screen (#124). */}
      <ol className="flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          const linkClasses =
            "font-medium text-primary-600 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 rounded-sm";
          return (
            <Fragment key={i}>
              {i > 0 && (
                <li aria-hidden="true" className="inline-flex">
                  <ChevronRight size={14} />
                </li>
              )}
              <li className="min-w-0 break-words">
                {isLast ? (
                  <span aria-current="page" className="font-medium text-text-primary">
                    {it.label}
                  </span>
                ) : it.href ? (
                  <a href={it.href} onClick={it.onClick} className={linkClasses}>
                    {it.label}
                  </a>
                ) : (
                  <button type="button" onClick={it.onClick} className={linkClasses}>
                    {it.label}
                  </button>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
